<template>
    <div class="rounded-sm overflow-hidden">
        <button
            class="bg-gray-50 font-medium flex items-center justify-between leading-none w-full focus:outline-none px-4 py-2"
            @click="collapsed = !collapsed"
        >
            {{ title || 'Toggle' }}

            <svg viewBox="0 0 20 20" fill="currentColor" class="chevron-down w-6 h-6 text-gray-500">
                <path
                    v-if="collapsed"
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                ></path>

                <path
                    v-else
                    fill-rule="evenodd"
                    d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                    clip-rule="evenodd"
                ></path>
            </svg>
        </button>
        <slot v-if="!collapsed" name="content" />
    </div>
</template>
<script>
export default {
    props: ['title'],
    methods: {},
    data() {
        return {
            collapsed: true,
        }
    },
}
</script>
